import { push } from 'connected-react-router'
import { sessionActions } from './session.actions'
import { sessionConstants } from '../constants'
import { userServices } from '../services'
import { alertActions } from './index'

export const userActions = {
  update,
  destroy,
}

function update(params) {
  return dispatch => {
    userServices.update(params).then(
      response => {
        const token = response.data.token
        localStorage.setItem('token', token)
        dispatch(authSuccess(token))
        dispatch(alertActions.success('Settings updated'))
      },
      error => {
        if (error.response) {
          const errors = error.response.data.errors
          if (errors) {
            errors.forEach(e => {
              dispatch(alertActions.error(e))
            })
          }
        }
      }
    )
  }

  //need this to update token values
  function authSuccess(token) {
    return { type: sessionConstants.SESSION_UPDATE_SUCCESS, token }
  }
}

function destroy(type) {
  return dispatch => {
    userServices.destroy(type).then(
      response => {
        dispatch(sessionActions.destroy())
        dispatch(alertActions.success("Account deleted"))
        dispatch(push('/'))
      },
      error => {
        if (error.response) {
          const errors = error.response.data.errors
          if (errors) {
            errors.forEach(e => {
              dispatch(alertActions.error(e))
            })
          }
        }
      }
    )
  }
}
